import { render, staticRenderFns } from "./Credits.vue?vue&type=template&id=fb70d666"
import script from "./Credits.vue?vue&type=script&lang=ts"
export * from "./Credits.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports